import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Button, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import * as action from '../../../actions/videos/trainingVideos';
import {
  DEFAULT_COLOR_OF_TRAINING_VIDEOS,
  DEFAULT_TRAINING_VIDEOS_PER_WEEK,
  DEFAULT_TRAINING_VIDEOS_PER_WEEK_ADDITIONAL_INFO,
  DEFAULT_TYPE_OF_VIDEOS_KEYS,
  SELF_DEVELOPMENT_VIDEO_TYPE_ID,
  MAIN_VIDEO_TYPE_ID,
} from '../../../constants/appConstants';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import SearchInput from '../../Common/SearchInput';
import FilteringByTagsBlock from '../../Common/FilteringByTagsBlock';
import { getTags } from '../../../actions/tags/getTags';
import TrainingLinks from '../TrainingLinks';
import GoToCreateButton from '../../UsersSubnavigation/GoToCreateButton';
import '../../../App.css';

const TemplateTrainingVideos = ({
  templateTrainingVideosList,
  setSubtemplateVideo,
  setTemplateVideo,
  getTemplateTrainingVideos,
  isLoadingDelete,
  isDeleteModal,
  deleteTemplateTrainingVideos,
  closeDeleteModal,
  openDeleteModal,
  templateTrainingVideosPageCount,
  templateTrainingVideosCurrentPage,
  searchTemplateVideosByName,
  getTags,
  setChoosedVideosTags,
  videosTags,
  allVideoTags,
}) => {
  const [currentVideosName, setCurrentVideosName] = useState('');
  const [currentVideosId, setCurrentVideosId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [isTagsOpened, setIsTagsOpened] = useState(false);

  const handleSubTemplateButton = React.useCallback(
    (subtemplate) => {
      setSubtemplateVideo(subtemplate);
    },
    [setSubtemplateVideo],
  );

  const handleEdit = React.useCallback(
    (template) => {
      setTemplateVideo(template);
    },
    [setTemplateVideo],
  );

  const handlePageClick = React.useCallback(
    (page) => {
      if (searchValue) {
        searchTemplateVideosByName(searchValue, page.selected + 1, videosTags);
      } else getTemplateTrainingVideos(page.selected + 1, videosTags);
    },
    [getTemplateTrainingVideos, searchValue],
  );

  const searchSubtemplateColor = React.useCallback(
    (templateDay) => {
      let selfDevelopmentVideo = false;
      let basicWorkoutVideo = false;
      let subtemplateNameColor = '';
      DEFAULT_TYPE_OF_VIDEOS_KEYS.map((videoType) => {
        const video = templateDay.videos[videoType];
        if (!video) return;

        if (video.video_type === SELF_DEVELOPMENT_VIDEO_TYPE_ID && video.url) {
          selfDevelopmentVideo = true;
          subtemplateNameColor = DEFAULT_COLOR_OF_TRAINING_VIDEOS[SELF_DEVELOPMENT_VIDEO_TYPE_ID];
        }
        if (video.video_type === MAIN_VIDEO_TYPE_ID && video.url) {
          basicWorkoutVideo = true;
          subtemplateNameColor = DEFAULT_COLOR_OF_TRAINING_VIDEOS[MAIN_VIDEO_TYPE_ID];
        }
        subtemplateNameColor = DEFAULT_COLOR_OF_TRAINING_VIDEOS[MAIN_VIDEO_TYPE_ID];
        return null;
      });
      if (selfDevelopmentVideo && basicWorkoutVideo) {
        subtemplateNameColor = `linear-gradient(45deg, ${DEFAULT_COLOR_OF_TRAINING_VIDEOS[SELF_DEVELOPMENT_VIDEO_TYPE_ID]}, ${DEFAULT_COLOR_OF_TRAINING_VIDEOS[MAIN_VIDEO_TYPE_ID]})`;
      }
      return subtemplateNameColor;
    },
    [DEFAULT_COLOR_OF_TRAINING_VIDEOS],
  );

  const onDeleteClick = React.useCallback((productId) => {
    deleteTemplateTrainingVideos(productId);
  });

  const openModal = (name, id) => {
    setCurrentVideosName(name);
    setCurrentVideosId(id);
    openDeleteModal();
  };

  const searchTemplateByTags = React.useCallback(
    (tags) => {
      searchTemplateVideosByName(searchValue, 1, tags);
    },
    [searchValue],
  );

  useEffect(() => {
    getTemplateTrainingVideos(templateTrainingVideosCurrentPage);
    getTags();
  }, []);

  const onCreateTemplate = () => {
    setTemplateVideo([]);
  };

  return (
    <TrainingContainer>
      <TrainingLinks title="Шаблоны видео тренировок" />
      <SearchInput
        placeholder="Поиск по шаблонам"
        getSearchItem={searchTemplateVideosByName}
        setSearchValue={setSearchValue}
        choosedTagsIds={videosTags}
      />
      <FilteringByTagsBlock
        getList={searchTemplateByTags}
        savedChoosedTags={videosTags}
        setChoosedTagsToStore={setChoosedVideosTags}
        tags={allVideoTags}
        setIsOpened={setIsTagsOpened}
        isOpened={isTagsOpened}
        applyButtonText="Фильтровать шаблоны тренировок"
        collapseTitleText="Фильтровать шаблоны тренировок"
      />
      <TableBlock>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Имя шаблона</Table.HeaderCell>
              {DEFAULT_TRAINING_VIDEOS_PER_WEEK.map((day, i) => {
                return (
                  <Table.HeaderCell key={day}>
                    <TemplateDay>{day}</TemplateDay>
                    <TemplateDay>{DEFAULT_TRAINING_VIDEOS_PER_WEEK_ADDITIONAL_INFO[i]}</TemplateDay>
                  </Table.HeaderCell>
                );
              })}
              <Table.HeaderCell>Теги видео</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {templateTrainingVideosList &&
              templateTrainingVideosList.map((template) => {
                const templateValue = template.complete_course;
                const subTemplateTags = [];
                return (
                  <React.Fragment key={template.id}>
                    <Table.Row>
                      <Table.Cell>{template.name}</Table.Cell>
                      {!!templateValue &&
                        templateValue.map((templateDay, i) => {
                          // eslint-disable-next-line react/no-array-index-key
                          if (!templateDay) return <Table.Cell key={template.id + i} />;
                          const subtemplateNameColor = searchSubtemplateColor(templateDay);
                          return (
                            // eslint-disable-next-line react/no-array-index-key
                            <Table.Cell key={templateDay.id + template.id + Math.random()}>
                              <SubTempaltesBlock>
                                <StyledLink
                                  onClick={() => handleSubTemplateButton(templateDay)}
                                  to="/changeSubtemplateVideos"
                                >
                                  <SubTemplateNameButton
                                    style={{ background: subtemplateNameColor }}
                                  >
                                    {templateDay.name}
                                  </SubTemplateNameButton>
                                </StyledLink>
                              </SubTempaltesBlock>
                            </Table.Cell>
                          );
                        })}
                      <Table.Cell>
                        {!!templateValue &&
                          templateValue.map((templateDay) => {
                            if (!templateDay) return;
                            return DEFAULT_TYPE_OF_VIDEOS_KEYS.map((videoType) => {
                              const subTemplate = templateDay.videos[videoType];
                              if (!subTemplate || !subTemplate.tags) return;
                              return (
                                !!subTemplate &&
                                subTemplate.tags.map((tag) => {
                                  if (!subTemplateTags.includes(tag.tag_id)) {
                                    subTemplateTags.push(tag.tag_id);
                                    return <TagsValue key={tag.tag_id}>{tag.name}</TagsValue>;
                                  }
                                  return null;
                                })
                              );
                            });
                          })}
                      </Table.Cell>

                      <Table.Cell>
                        <EditBlock>
                          <StyledLink
                            to="/changeTemplateVideos"
                            onClick={() => handleEdit(template)}
                          >
                            <Button primary icon>
                              <Icon name="edit" />
                            </Button>
                          </StyledLink>
                        </EditBlock>
                        <Button icon negative onClick={() => openModal(template.name, template.id)}>
                          <Icon name="trash" />
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  </React.Fragment>
                );
              })}
          </Table.Body>
        </Table>
      </TableBlock>
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        pageCount={templateTrainingVideosPageCount}
        marginPagesDisplayed={3}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        previousLinkClassName="prev-page-btn"
        nextLinkClassName="next-page-btn"
        containerClassName="pagination"
        activeLinkClassName="active-page-btn"
        pageLinkClassName="page-btn"
        breakClassName="break-me"
        background="white"
      />
      <DeleteConfirmPopup
        isLoadingDelete={isLoadingDelete}
        isOpen={isDeleteModal}
        title={currentVideosName}
        onDelete={() => onDeleteClick(currentVideosId)}
        onCancel={closeDeleteModal}
      />
      <PlusButton onClick={onCreateTemplate}>
        <GoToCreateButton link="/changeTemplateVideos" />
      </PlusButton>
    </TrainingContainer>
  );
};

const mapStateToProps = (state) => {
  const {
    trainingVideos,
    templateTrainingVideosList,
    isLoadingDelete,
    isDeleteModal,
    templateTrainingVideosPageCount,
    templateTrainingVideosCurrentPage,
    videosTags,
  } = state.trainingVideos;
  const { allVideoTags } = state.getTags;

  return {
    trainingVideos,
    templateTrainingVideosList,
    isLoadingDelete,
    isDeleteModal,
    templateTrainingVideosPageCount,
    templateTrainingVideosCurrentPage,
    videosTags,
    allVideoTags,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubtemplateVideo: (subtemplateVideo) => {
      dispatch(action.setSubtemplateVideo(subtemplateVideo));
    },
    getTemplateTrainingVideos: (page) => {
      dispatch(action.getTemplateTrainingVideos(page));
    },
    deleteTemplateTrainingVideos: (productId) => {
      dispatch(action.deleteTemplateTrainingVideos(productId));
    },
    closeDeleteModal: () => {
      dispatch(action.closeDeleteModal());
    },
    openDeleteModal: () => {
      dispatch(action.openDeleteModal());
    },
    setTemplateVideo: (templateVideo) => {
      dispatch(action.setTemplateVideo(templateVideo));
    },
    searchTemplateVideosByName: (name, page, tags) => {
      dispatch(action.searchTemplateVideosByName(name, page, tags));
    },
    setChoosedVideosTags: (tags) => {
      dispatch(action.setChoosedVideosTags(tags));
    },
    getTags: () => {
      dispatch(getTags());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateTrainingVideos);

const TrainingContainer = styled.div`
  width: 90%;
  margin: 0 auto 10px auto;
  @media (max-width: 992px) {
    width: 80%;
  }
`;
const TemplateDay = styled.div`
  text-align: center;
`;
const TagsValue = styled.p`
  margin-bottom: 0;
  text-align: center;
  background-color: #6acdf0;
  border: 1px solid white;
  border-radius: 5px;
`;
const TableBlock = styled.div`
  overflow: auto;
  width: 100%;
  margin-top: 10px;
`;

const EditBlock = styled.div`
  margin-bottom: 5px;
`;

const SubTemplateNameButton = styled.button`
  width: 100%;
  margin-bottom: 0;
  padding: 5px;
  background-color: transparent;
  text-align: center;
  border: 0px;
  border-radius: 4px;
  color: black;
  &:hover {
    color: white;
  }
`;

const SubTempaltesBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const activeClassName = 'active';
const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})``;

const PlusButton = styled.button`
  position: fixed;
  width: 80px;
  height: 80px;
  right: 25px;
  bottom: 25px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background: #5da834;
  color: #fff;
  border-radius: 50%;
  border: 2px solid #000542;
  &:hover {
    background: #1b8100;
  }
  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
  @media (max-width: 500px) {
    right: 15px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Training/TrainingList/TemplateTrainingVideos.jsx